<template>
  <div>
    <v-dialog
      v-model="movementErrorModal"
      persistent
      width="1000">
      <v-card>
        <v-card-title>
          <v-row>
            <v-col
              cols="6"
              class="d-flex justify-start">
              <span
                class="primary--text font-weight-bold text-h5">
                Erro de movimentação
              </span>
            </v-col>

            <v-col
              cols="6"
              class="d-flex justify-end">
              <v-icon
                @click="closeModal()">
                fas fa-times
              </v-icon>
            </v-col>

            <v-col
              v-if="isMovementError"
              cols="12">
              Nome:
              <span
                class="font-weight-bold primary--text">
                {{ insuredName || '-' }}
              </span>
            </v-col>

            <template
              v-if="isShippingBatchesError">
              <v-col
                v-if="statusMovementIsTransformationError"
                cols="12">
                <span
                  class="font-weight-bold primary--text">
                  Esse lote tem movimentações com erros de transformação
                </span>
              </v-col>

              <v-col
                v-if="statusMovementIsConversionError && hasErrors"
                class="my-5 ml-3" cols="12">
                <v-row
                  class="primary--text">
                  {{ errors[0].message || '-' }}
                </v-row>
              </v-col>
            </template>
          </v-row>
        </v-card-title>

        <v-card-text
          v-if="!isShippingBatchesError"
          :class="
            isFileMovementError
              ? 'mt-10 pb-2'
              : ''">
          <div
            v-if="hasErrorReportRow"
            class="d-flex flex-row justify-end align-center mb-2">
            <div
              class="d-flex flex-row align-center">
              Ações:
              <v-menu
                transition="slide-y-transition"
                offset-y>
                <template
                  v-slot:activator="{ on, attrs }">
                  <v-sheet
                    color="primary"
                    height="22"
                    width="22"
                    class="d-flex align-center justify-center rounded-circle ml-2"
                    v-bind="attrs"
                    v-on="on">
                    <v-icon
                      size="14"
                      color="foreground-accent">
                      fas fa-ellipsis-v
                    </v-icon>
                  </v-sheet>
                </template>

                <TodoListActions
                  :actions="actions"
                />
              </v-menu>
            </div>
          </div>

          <v-data-table
            :headers="headers"
            :items="errors"
            :items-per-page="10"
            :loading="isLoadingTable"
            class="elevation-1"
            :show-expand="isFileMovementError"
            :single-expand="isFileMovementError"
            :expanded.sync="expanded"
            item-key="lineNumber"
            :height="hasErrors && errors.length > 6 ? 336 : 'auto'">
            <template v-slot:[`header.lineNumber`]="{ header }">
              <span>
                {{
                  isFileMovementError
                  ? header.text
                  : null
                }}
              </span>
            </template>

            <template v-slot:[`item.message`]="{ item }">
              <span>
                {{ item.message || '-' }}
              </span>
            </template>

            <template v-slot:[`item.columnError`]="{ item }">
              <span>
                {{
                  item.columnError &&
                  item.columnError.trim().length > 0
                    ? item.columnError
                    : '-'
                }}
              </span>
            </template>

            <template v-slot:[`item.lineNumber`]="{ item }">
              <span>
                {{
                  item.lineNumber
                    ? item.lineNumber
                    : isFileMovementError && !item.lineNumber
                      ? '-'
                      : ''
                }}
              </span>
            </template>

            <template v-slot:[`item.createdAt`]="{ item }">
              <span>
                {{
                  item.createdAt
                    ? formatter.formatDateTimeZone(item.createdAt)
                    : '-'
                }}
              </span>
            </template>

            <template v-slot:[`item.benefitDescription`]="{ item }">
              <span>
                {{
                  item.benefitDescription &&
                  item.benefitDescription.trim().length > 0
                    ? item.benefitDescription.trim()
                    : '-'
                }}
              </span>
            </template>

            <template v-slot:[`item.detail`]="{ item }">
              <v-menu
                bottom
                left>
                <template
                  v-slot:activator="{ on, attrs }">
                  <v-btn
                    :disabled="item.detail === null"
                    color="primary"
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="onClickDetail(item)">
                    Ver detalhes
                  </v-btn>
                </template>
              </v-menu>
            </template>

            <template v-slot:[`item.data-table-expand`]="{ item, isExpanded, expand, index }">
              <v-badge
                left
                top
                overlap
                color="error"
                :content="amountUpdatedErrors(item)"
                :value="amountUpdatedErrors(item)">
                <v-icon
                  :class="[
                    'v-data-table__expand-icon',
                    { 'v-data-table__expand-icon--active': (isExpanded) }
                  ]"
                  @click.stop="expand(!isExpanded)">
                  $expand
                </v-icon>
              </v-badge>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
              <td
                :colspan="headers.length"
                class="px-0">
                <v-data-table
                  :headers="columnHeaders"
                  :items="item.columns"
                  hide-default-footer
                  height="215"
                  :item-class="item => !item.inEditing && isErrorUpdated(item) ? 'lineErrorUpdated' : ''"
                  fixed-header>
                  <template v-slot:[`item.createdAt`]="{ item }">
                    <span>
                      {{
                        item.createdAt
                          ? formatter.formatDateTimeZone(item.createdAt)
                          : '-'
                      }}
                    </span>
                  </template>

                  <template v-slot:[`item.message`]="{ item }">
                    <div
                      class="d-flex flex-row align-center justify-space-between">
                      <span>
                        {{ item.message || '-' }}
                      </span>

                      <v-tooltip
                        bottom
                        :disabled="!item.detail">
                        <template v-slot:activator="{ on, attrs }">
                          <v-sheet
                            v-if="item.detail"
                            color="primary"
                            height="20"
                            min-width="20"
                            class="d-flex align-center justify-center rounded-circle ml-1"
                            v-on="on"
                            v-bind="attrs">
                            <v-icon
                              size="14"
                              color="foreground-accent">
                              fas fa-info
                            </v-icon>
                          </v-sheet>
                        </template>

                        <span>
                          {{ item.detail }}
                        </span>
                      </v-tooltip>
                    </div>
                  </template>

                  <template v-slot:[`item.columnName`]="{ item }">
                    <div
                      :class="{
                        'd-flex flex-row align-center': true,
                        ' justify-space-between': item.columnName,
                        ' justify-end': !item.columnName,
                      }">
                      <span>
                        {{ item.columnName || '' }}
                      </span>

                      <v-tooltip
                        bottom
                        v-if="!isAllowedToReviewLine(item)">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-on="on"
                            v-bind="attrs"
                            color="error"
                            size="20"
                            :class="hasColumnName(item) ? 'ml-2' : ''">
                            fas fa-times
                          </v-icon>
                        </template>
                        <span>
                          {{ reviewMessageError(item) }}
                        </span>
                      </v-tooltip>
                    </div>
                  </template>

                  <template v-slot:[`item.columnValue`]="{ item }">
                    <div
                      class="d-flex flex-row align-center">
                      <v-text-field
                        class="movementErrorValueTextField"
                        :value="item.columnValue"
                        outlined
                        hide-details
                        dense
                        :disabled="!item.inEditing"
                        @input="setColumnValue(item, $event)">
                        <template v-slot:append>
                          <div
                            class="d-flex align-center fill-height">
                            <v-tooltip
                              bottom
                              :disabled="!item.detail">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-on="on"
                                  v-bind="attrs"
                                  size="15"
                                  :disabled="!isAllowedToReviewLine(item)"
                                  :color="item.inEditing ? 'primary' : 'foreground'"
                                  @click="setRevalidation(item)">
                                  fas fa-pen
                                </v-icon>
                              </template>
                              <span>
                                {{
                                  !isAllowedToReviewLine(item)
                                  ? reviewMessageError(item)
                                  : 'Editar'
                                }}
                              </span>
                            </v-tooltip>
                          </div>
                        </template>
                      </v-text-field>

                      <v-tooltip
                        bottom
                        v-if="isErrorUpdated(item) && item.inEditing === false">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-on="on"
                            v-bind="attrs"
                            class="ml-2"
                            size="15"
                            @click="roolbackColumnValue(item)">
                            far fa-clock
                          </v-icon>
                        </template>
                        <span>Resetar alteração</span>
                      </v-tooltip>

                      <v-tooltip
                        bottom
                        v-if="hasMovementRecord(item)">
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-on="on"
                            v-bind="attrs"
                            style="max-height: 18px;">
                            <v-icon
                              class="ml-2"
                              size="15"
                              @click="goToMovementRecord(item)">
                              far fa-eye
                            </v-icon>
                          </div>
                        </template>
                        <span>Buscar movimentação</span>
                      </v-tooltip>
                    </div>
                  </template>
                </v-data-table>
              </td>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <div
            class="d-flex flex-row justify-end px-2 pb-3"
            style="width: 100%;">
            <v-btn
              v-if="
                !isFileMovementError
                && !isMovementError"
              color="primary"
              class="rounded-lg"
              @click="onClickDetail()"
              style="width: 200px; font-size: 16px;">
              {{
                isShippingBatchesError
                  ? 'Ver detalhes'
                  : 'OK'
              }}
            </v-btn>

            <v-btn
              v-if="isFileMovementError"
              color="primary"
              outlined
              class="rounded-lg"
              @click="closeModal()"
              style="width: 200px; font-size: 16px;">
              Cancelar
            </v-btn>

            <v-btn
              v-if="isFileMovementError"
              color="primary"
              class="foreground-accent--text ml-4 rounded-lg"
              style="width: 200px; font-size: 16px;"
              :disabled="!errorsToRevalidate.length"
              :loading="loadingRevalidation"
              @click="saveRevalidation()">
              Salvar
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DynamicDialogInformation
      ref="DynamicDialogInformation">
      <v-row
        class="mb-3"
        justify="center"
        slot="textInfo"
        style="word-break: break-word">
        <v-col
          cols="12"
          align="center">
          <label
            class="label">
            Informações técnicas:
          </label>
        </v-col>
        {{
          detailError && detailError.detail
            ? detailError.detail
            : 'Não há detalhes'
        }}
      </v-row>
    </DynamicDialogInformation>

    <SnackbarCustomize
      ref="SnackbarCustomize"
    />
  </div>
</template>

<script>
import Formatters from '@/shared/formatters/formatters';
import DynamicDialogInformation from '@/components/DynamicDialogInformation/DynamicDialogInformation.vue';
import FileDataService from '@/services-http/sdi/FileDataService';
import SnackbarCustomize from '@/components/CustomAlerts/SnackbarCustomize.vue';
import ReportService from '@/services-http/sdi/ReportService';
import TodoListActions from '@/components/TodoList/TodoListActions.vue';
import AuthorityManagementMixin from '@/shared/mixins/authorityManagement/authorityManagementMixin';
import { store, observableMutations } from '@/shared/observable/store';

export default {
  name: 'MovementErrorModal',

  components: {
    DynamicDialogInformation,
    SnackbarCustomize,
    TodoListActions,
  },

  data: () => ({
    movementErrorModal: false,
    isLoadingTable: false,
    detailError: '',
    errors: [],
    expanded: [],
    errorsToRevalidate: [],
    loadingRevalidation: false,
  }),

  props: {
    movementError: Array,
    movementErrorSourceId: {
      type: [Number, String],
      default: null,
    },
    insuredName: String,
    insuranceCarrierIdWithError: null,
    loadingTableMovementError: Boolean,
    tabError: String,
    statusMovement: String,
    hasErrorReportRow: {
      type: Boolean,
      default: true,
    },
  },

  mixins: [
    AuthorityManagementMixin,
  ],

  watch: {
    movementError: {
      handler(val) {
        if (val && val.length > 0) {
          if (this.isFileMovementError) {
            this.mountLineErrors(val);
            return;
          }

          this.errors = val;
        }
      },
      deep: true,
    },
    loadingTableMovementError: {
      handler(val) {
        this.isLoadingTable = val;
      },
      deep: true,
    },
  },

  methods: {
    openModal() {
      this.expanded = [];
      this.errors = [];
      this.errorsToRevalidate = [];
      this.movementErrorModal = true;
    },

    closeModal() {
      this.errorsToRevalidate = [];
      this.movementErrorModal = false;
    },

    isAllowedToReviewLine(item) {
      if (!this.hasColumnName(item)) return false;
      if (this.hasMovementRecord(item)) return false;
      return true;
    },

    reviewMessageError(item) {
      if (!this.hasColumnName(item)) return 'Não é possível editar esse erro, faça o upload do arquivo corrigido para prosseguir.';

      if (this.hasMovementRecord(item)) return 'Não é possível editar esse erro, pois a movimentação já está criada. Realize a correção pela movimentação.';
    },

    hasColumnName(item) {
      return item && item.columnName;
    },

    hasMovementRecord(item) {
      return item && item.movementRecordId;
    },

    goToMovementRecord(item) {
      this.$emit('getMovementByMovementRecordId', item.movementRecordId);
      this.$nextTick(() => this.closeModal());
    },

    onClickDetail(item) {
      if (this.statusMovementIsTransformationError) {
        this.$emit('redirectMovements', this.insuranceCarrierIdWithError, null);
        this.closeModal();
      } else {
        this.$refs.DynamicDialogInformation.open();
        this.detailError = item;
      }
    },

    async downloadFile() {
      const fileDataService = new FileDataService();
      const id = this.errors[0].fileDataId;
      const previousCustomDialogState = store.isCustomDialog;

      store.isCustomDialog = true;
      this.isLoadingTable = true;

      try {
        const response = await fileDataService.downloadFileMovementCritical(id);

        if (response) {
          const filename = response.headers['content-disposition'].split('"');
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');
          const nameDecoded = decodeURIComponent(filename[1]);

          fileLink.href = fileURL;
          fileLink.setAttribute('download', nameDecoded);
          document.body.appendChild(fileLink);

          fileLink.click();
          this.$refs.SnackbarCustomize.open('success', 'Download realizado com sucesso.', 3000);
        }
      } catch {
        observableMutations.setDialogInformation({
          viewMovements: false,
          skipDuplicityCheck: false,
          data: {
            code: 412,
            codeMessage: 'file.data.download.error',
          },
          show: true,
        });
      } finally {
        this.isLoadingTable = false;
        store.isCustomDialog = previousCustomDialogState;
      }
    },

    downloadReport() {
      const reportService = new ReportService();

      const id = Number(this.movementErrorSourceId);

      if (!id || Number.isNaN(id)) {
        this.$refs.SnackbarCustomize.open('error', 'Não foi possível identificar a origem do relatório de erros.');
        return;
      }

      this.isLoadingTable = true;

      const downloadPromise = this.isFileMovementError
        ? reportService.findReportByFileData(id)
        : this.isMovementError
          ? reportService.findReportByMovementRecordId(id)
          : null;

      if (!downloadPromise) {
        this.isLoadingTable = false;
        this.$refs.SnackbarCustomize.open('error', 'Relatório de erros não disponível para esta origem.');
        return;
      }

      downloadPromise.then((response) => {
        if (response) {
          const filename = response.headers['content-disposition'].split('"');
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');
          const nameDecoded = decodeURIComponent(filename[1]);

          fileLink.href = fileURL;
          fileLink.setAttribute('download', nameDecoded);
          document.body.appendChild(fileLink);

          fileLink.click();
          this.isLoadingTable = false;
          this.$refs.SnackbarCustomize.open('success', 'Download realizado com sucesso.', 3000);
        }
      }).catch((error) => {
        this.isLoadingTable = false;

        if (error && error.response && error.response.data) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const parsedError = JSON.parse(reader.result);
              this.$refs.SnackbarCustomize.open('error', parsedError.message || 'Ocorreu um erro ao tentar efetuar o download.');
            } catch {
              this.$refs.SnackbarCustomize.open('error', 'Ocorreu um erro ao tentar efetuar o download.');
            }
          };
          reader.readAsText(error.response.data);
          return;
        }

        this.$refs.SnackbarCustomize.open('error', 'Ocorreu um erro ao tentar efetuar o download.');
      });
    },

    async saveRevalidation() {
      const fileDataService = new FileDataService();

      this.loadingRevalidation = true;

      const { fileDataId } = this.errors[0];

      await fileDataService.makeRevalidation(fileDataId, this.errorsToRevalidate)
        .then((response) => {
          this.$refs.SnackbarCustomize.open('success', 'Revalidação realizado com sucesso.');
          this.closeModal();
        })
        .catch((error) => {
          this.$refs.SnackbarCustomize.open('error', 'Ocorreu um erro ao tentar realizar a Revalidação.');
        })
        .finally(() => this.loadingRevalidation = false);
    },

    setColumnValue(error, value) {
      error.updatedValue = value;
    },

    setRevalidation(error) {
      if (!error.inEditing) {
        error.inEditing = true;
        return;
      }

      error.inEditing = false;

      this.startRevalidation(error);

      error.columnValue = error.updatedValue;
    },

    startRevalidation(error) {
      if (this.isErrorUpdated(error)) {
        this.setErrorToRevalidation(error);
      } else {
        this.checkAndRemoveErrors(error);
      }
    },

    checkAndRemoveErrors(error) {
      const fileDateRecordIndex = this.getFileRecordIndex(error);

      if (fileDateRecordIndex === -1) return;

      const columnIndex = this.getFileColumnIndex(error, fileDateRecordIndex);

      if (columnIndex === -1) return;

      const columnErrors = this.errorsToRevalidate[fileDateRecordIndex].columns;

      if (columnErrors && columnErrors.length === 1) {
        this.errorsToRevalidate.splice(fileDateRecordIndex, 1);

        return;
      }

      if (columnErrors && columnErrors.length > 1) {
        this.errorsToRevalidate[columnIndex].columns.splice(columnIndex, 1);
      }
    },

    setErrorToRevalidation(error) {
      const fileDateRecordIndex = this.getFileRecordIndex(error);

      if (fileDateRecordIndex !== -1) {
        const columnIndex = this.getFileColumnIndex(error, fileDateRecordIndex);

        if (columnIndex === -1) {
          this.errorsToRevalidate[fileDateRecordIndex].columns.push({
            columnName: error.columnName,
            columnValue: error.updatedValue,
          });

          return;
        }

        this.errorsToRevalidate[fileDateRecordIndex].columns[columnIndex].columnValue = error.updatedValue;

        return;
      }

      this.addNewErrorToValidation(error);
    },

    getFileRecordIndex(error) {
      return this.errorsToRevalidate.findIndex(
        (item) => this.fileDataRecordFinder(item, error),
      );
    },

    getFileColumnIndex(error, fileDateRecordIndex) {
      return this.errorsToRevalidate[fileDateRecordIndex].columns.findIndex(
        (item) => this.columnErrorFinder(item, error),
      );
    },

    roolbackColumnValue(error) {
      error.columnValue = error.currentValue;
      error.updatedValue = error.currentValue;

      this.startRevalidation(error);
    },

    addNewErrorToValidation(error) {
      this.errorsToRevalidate.push({
        fileDataRecordId: error.fileDataRecordId,
        columns: [
          {
            columnName: error.columnName,
            columnValue: error.updatedValue,
          },
        ],
      });
    },

    fileDataRecordFinder(item, error) {
      return item.fileDataRecordId === error.fileDataRecordId;
    },

    columnErrorFinder(item, error) {
      return item.columnName === error.columnName;
    },

    amountUpdatedErrors(line) {
      const errorsUpdated = line.columns.filter((columnError) => this.isErrorUpdated(columnError));

      return errorsUpdated && errorsUpdated.length > 0 ? errorsUpdated.length : 0;
    },

    mountLineErrors(movementError) {
      const lines = [...new Set(movementError.map((error) => error.lineNumber))];

      lines.forEach((lineNumber) => {
        const errorColumns = movementError.filter((error) => error.lineNumber === lineNumber);

        const errorLine = this.mountErrorObject(lineNumber, errorColumns);

        this.errors.push(errorLine);
      });
    },

    mountErrorObject(lineNumber, errorColumns) {
      const columns = errorColumns.map((error) => ({
        ...error,
        currentValue: error.columnValue,
        updatedValue: error.columnValue,
        inEditing: false,
      }));

      return {
        fileDataId: errorColumns[0].fileDataId,
        layoutId: errorColumns[0].layoutId,
        lineNumber,
        amount: errorColumns.length,
        columns,
      };
    },

    isErrorUpdated(error) {
      return error.currentValue != error.updatedValue;
    },
  },

  computed: {
    actions() {
      return [
        {
          label: 'Relatório de erros',
          icon: 'fas fa-print',
          condition: true,
          handler: () => this.downloadReport(),
        },
        {
          label: 'Baixar arquivo para correção',
          icon: 'fas fa-download',
          condition: true,
          disabled: this.hasLayout,
          handler: () => this.downloadFile(),
        },
      ];
    },

    headers() {
      if (this.isFileMovementError) {
        return [
          {
            text: 'Linha',
            align: 'start',
            value: 'lineNumber',
            sortable: false,
          },
          {
            text: 'Beneficiário',
            align: 'start',
            value: 'benefitDescription',
            sortable: false,
          },
          {
            text: 'Quant. Erros',
            align: 'start',
            value: 'amount',
            sortable: false,
          },
          {
            text: '',
            value: 'data-table-expand',
          },
        ];
      }

      return [
        {
          text: 'Data',
          align: 'center',
          value: 'createdAt',
          sortable: false,
        },
        {
          text: 'Descrição do Erro',
          align: 'center',
          value: 'message',
          sortable: false,
        },
        {
          text: 'Coluna do Erro',
          align: 'center',
          value: 'columnError',
          sortable: false,
        },
        {
          text: 'Linha do Erro',
          align: 'center',
          value: 'lineNumber',
          sortable: false,
        },
        {
          text: 'Beneficiário',
          align: 'center',
          value: 'benefitDescription',
          sortable: false,
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'detail',
          sortable: false,
        },
      ];
    },

    columnHeaders() {
      const headers = [
        {
          text: 'Data',
          align: 'start',
          value: 'createdAt',
          sortable: false,
        },
        {
          text: 'Descrição',
          align: 'start',
          value: 'message',
          sortable: false,
        },
        {
          text: 'Coluna',
          align: 'start',
          value: 'columnName',
          sortable: false,
        },
      ];

      if (this.hasPermission('sdi_movimentacao_arquivo_acao_corrigir_linha')) {
        headers.push({
          text: 'Valor',
          align: 'start',
          value: 'columnValue',
          sortable: false,
          width: '250px',
        });
      }

      return headers;
    },

    isFileMovementError() {
      return this.tabError === 'protocol';
    },

    isMovementError() {
      return this.tabError === 'movement';
    },

    isShippingBatchesError() {
      return this.tabError === 'batch';
    },

    statusMovementIsTransformationError() {
      return this.statusMovement === 'TRANSFORMATION_ERROR';
    },

    statusMovementIsConversionError() {
      return this.statusMovement === 'CONVERSION_ERROR';
    },

    hasLayout() {
      return this.hasErrors && this.errors[0].layoutId === null;
    },

    hasErrors() {
      return this.errors && this.errors.length > 0;
    },
  },

  created() {
    this.formatter = new Formatters();
  },
};
</script>

<style lang="scss">
.movementErrorValueTextField {
  > .v-input__control {
    > .v-input__slot {
      > .v-input__append-inner {
        margin: 8px 0 !important;
        display: flex;
        align-self: center;
      }
    }
  }
}
.lineErrorUpdated {
  box-shadow: inset 0 0 0 2px var(--v-primary-base);
}
</style>
